"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getK8sBaseUrl = void 0;
var k8sBaseUrls = {
    development: 'apps.zagforward.com/edge/splittest',
    test: 'apps.carvanatech.com/edge/splittest',
    uat: 'apps.cvuat.com/edge/splittest',
    production: 'apps.carvana.io/edge/splittest',
    unknown: ''
};
var getK8sBaseUrl = function (environment) {
    if (environment === void 0) { environment = process.env.NODE_ENV; }
    return k8sBaseUrls[environment];
};
exports.getK8sBaseUrl = getK8sBaseUrl;
exports.default = exports.getK8sBaseUrl;
